import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { compose, withProps } from 'recompose';
import { LanguageSelect, ILanguageSelectProps } from './LanguageSelect';
import * as _ from 'lodash';

const GetLanguagesListQuery = gql`
  query {
    languages {
      id
      value
    }
  }
`;

export default compose<{}, ILanguageSelectProps>(
  graphql<ILanguageSelectProps, any>(GetLanguagesListQuery, {
    name: 'languages',
  }),
  withProps(({ languages }: any) => {
    return {
      languages: languages.languages,
    };
  }),
)(LanguageSelect);



// WEBPACK FOOTER //
// ./src/components/Others/LanguageSelect/index.ts